import styled from 'styled-components';

export const ModalContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

export const SplashImage = styled.img`
  width: 100%;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 8px;

  @media (max-width: 768px) { max-height: 70vh; }
`;

export const DismissContainer = styled.div`
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);

  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;

  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(6px);
  border-radius: 20px;
  white-space: nowrap;
  transition: background 0.2s ease, transform 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.65);
    transform: translateX(-50%) scale(1.03);
  }
`;

export const DismissCheckbox = styled.input`
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #fff;
  flex-shrink: 0;
`;

export const DismissLabel = styled.label`
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  user-select: none;
`;